//MERK denne regexen MÅ være i sync med det java produserer
// - se no.systemfabrikken.lederplan.infrastruktur.jackson.LederplanJacksonModul for hvilket format java produserer
var regexIso8601 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:\.\d{1,})?Z$/;

/**
 * Finner alle stenger i angitt struktur som matcher Iso8601 formatet og konverterer disse til Date objekter.
 *
 * Merk at javascript kun støtter millisekundpresisjon for dato. Safari og Chrome håndtere parsing av dato
 * med nanosekundpresisjon ulikt, eks:
 *
 * I Safari - runder av nanosekunder :
 * Date.parse('2007-12-04T23:59:59.999999999Z') == 1196812800000
 * new Date(Date.parse('2007-12-04T23:59:59.999999999Z')).toISOString() == '2007-12-05T00:00:00.000Z'
 *
 * I Chrome - trunkerer nanosekunder ::
 * Date.parse('2007-12-04T23:59:59.999999999Z') == 1196812799999
 * new Date(Date.parse('2007-12-04T23:59:59.999999999Z')).toISOString() == '2007-12-04T23:59:59.999Z'
 */
export function konverterIso8601DatoStrengTilDate<T>(struktur: T): T {
    // ignorer ikke-objekter
    if (typeof struktur !== "object") return struktur;

    for (var nøkkel in struktur) {
        if (!struktur.hasOwnProperty(nøkkel)) continue;

        var verdi = struktur[nøkkel];
        // er dette en dato-formatert streng?
        if (typeof verdi === "string" && verdi.match(regexIso8601)) {
            var milliseconds = Date.parse(verdi);
            if (!isNaN(milliseconds))
                struktur[nøkkel] = <any>new Date(milliseconds);

        } else if (typeof verdi === "object")
        // nøst ned i objektet
            konverterIso8601DatoStrengTilDate(verdi);
    }

    return struktur;
}

export function konverterIso8601DatoStrengTilDateAngularConfig() {
    return [
        "$httpProvider",
        ($httpProvider) => $httpProvider.defaults.transformResponse.push(konverterIso8601DatoStrengTilDate)
    ];
}
